import { useKeycloak } from '@react-keycloak/web';

const defaultUri = 'http://localhost:3000/';

const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isInContainer = window.location.port === '';

const redirectUri = !isLocalhost
  ? `${window.location.protocol}//${window.location.hostname}/`
  : isInContainer
    ? 'http://localhost/'
    : defaultUri;

const loginOptions = {
  redirectUri: redirectUri,
};

export const ProtectedRoute = (props) => {
  const { element: Element } = props;
  const { keycloak, initialized } = useKeycloak();

  if (!initialized) return null;
  if (!keycloak.authenticated) {
    return null;
  }

  return <Element></Element>;
};
